import { EntityAlert } from "../../entity/EntityAlert";

export class DtoAlertsDeleteRes extends EntityAlert {
  public message: string | null = null;
}
